var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
__name(_createClass, "_createClass");
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function _isNativeReflectConstruct2() {
    return !!t;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
__name(_setPrototypeOf, "_setPrototypeOf");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React, { Component } from "react";
import classNames from "classnames";
import { Button } from "../../button/Button";
import { expandableOverflowCls, expandableOverflowMountedCls, expandableOverflowCondensedCls, expandableOverflowContentCls, expandableOverflowContentGrayCls, expandableOverflowContentSectionBlackCls, expandableOverflowFooterCls, expandableOverflowBtnHiddenCls } from "./Overflow.less";
var ExpandableOverflow = /* @__PURE__ */ function(_Component) {
  function ExpandableOverflow2(props) {
    var _this;
    _classCallCheck(this, ExpandableOverflow2);
    _this = _callSuper(this, ExpandableOverflow2, [props]);
    _this.contentRef = /* @__PURE__ */ React.createRef();
    _this.state = {
      isMounted: false,
      shouldBeExpandable: false,
      isExpanded: false,
      clientHeight: 0
    };
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }
  __name(ExpandableOverflow2, "ExpandableOverflow");
  _inherits(ExpandableOverflow2, _Component);
  return _createClass(ExpandableOverflow2, [{
    key: "componentDidMount",
    value: /* @__PURE__ */ __name(function componentDidMount() {
      var _ref = this.contentRef && this.contentRef.current || {}, _ref$clientHeight = _ref.clientHeight, clientHeight = _ref$clientHeight === void 0 ? 0 : _ref$clientHeight;
      this.setState({
        isMounted: true,
        shouldBeExpandable: clientHeight > this.props.maxHeight,
        clientHeight
      });
    }, "componentDidMount")
  }, {
    key: "componentDidUpdate",
    value: /* @__PURE__ */ __name(function componentDidUpdate(prevProps, prevState) {
      var _ref2 = this.contentRef && this.contentRef.current || {}, _ref2$clientHeight = _ref2.clientHeight, clientHeight = _ref2$clientHeight === void 0 ? 0 : _ref2$clientHeight;
      if (this.props.children && this.props.children.key && prevProps.children && prevProps.children.key && this.props.children.key !== prevProps.children.key || this.props.maxHeight !== prevProps.maxHeight || prevState.isExpanded === this.state.isExpanded && prevState.clientHeight !== clientHeight) {
        this.setState({
          isExpanded: false,
          shouldBeExpandable: clientHeight > this.props.maxHeight,
          clientHeight
        });
      }
    }, "componentDidUpdate")
    /**
     * handleClick
     *
     * @param {Object} e
     */
  }, {
    key: "handleClick",
    value: /* @__PURE__ */ __name(function handleClick(e) {
      e.preventDefault();
      this.setState(function(prevState) {
        return {
          isExpanded: !prevState.isExpanded
        };
      });
    }, "handleClick")
    /**
     * render
     */
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function render() {
      var _this$props = this.props, maxHeight = _this$props.maxHeight, className = _this$props.className, children = _this$props.children, footerChildren = _this$props.footerChildren, gradientColor = _this$props.gradientColor, showMore = _this$props.showMore, showLess = _this$props.showLess, initialyExpandable = _this$props.initialyExpandable;
      var _this$state = this.state, isExpanded = _this$state.isExpanded, shouldBeExpandable = _this$state.shouldBeExpandable, isMounted = _this$state.isMounted;
      if (!children) {
        return null;
      }
      return /* @__PURE__ */ React.createElement("div", {
        className: classNames(expandableOverflowCls, (isMounted || initialyExpandable) && expandableOverflowMountedCls, (!isMounted && initialyExpandable || !isExpanded && shouldBeExpandable) && expandableOverflowCondensedCls, className)
      }, /* @__PURE__ */ React.createElement("div", _extends({
        className: classNames(expandableOverflowContentCls, gradientColor === "gray" && expandableOverflowContentGrayCls, gradientColor === "sectionBlack" && expandableOverflowContentSectionBlackCls)
        // $FlowFixMe
      }, !isExpanded && shouldBeExpandable || !isMounted ? {
        style: {
          maxHeight: "".concat(maxHeight, "px")
        }
      } : {}), /* @__PURE__ */ React.createElement("div", {
        ref: this.contentRef
      }, children)), footerChildren || initialyExpandable || isMounted && shouldBeExpandable ? /* @__PURE__ */ React.createElement("div", {
        className: expandableOverflowFooterCls
      }, initialyExpandable && !footerChildren || isMounted && shouldBeExpandable ? /* @__PURE__ */ React.createElement(Button, {
        type: "link",
        onClick: this.handleClick,
        className: classNames(initialyExpandable && !footerChildren && (!isMounted || !shouldBeExpandable) && expandableOverflowBtnHiddenCls)
      }, isExpanded ? showLess : showMore) : null, footerChildren) : null);
    }, "render")
  }]);
}(Component);
_defineProperty(ExpandableOverflow, "defaultProps", {
  maxHeight: 350,
  className: null,
  footerChildren: null,
  gradientColor: null,
  initialyExpandable: true
});
export {
  ExpandableOverflow
};
